import "./_module.scss";

import {ReactElement} from "react";

import {
  OperationCommercial,
  OperationCommercialSkeleton,
} from "@/components/OperationCommercial/OperationCommercial";
import Section from "@/components/Section/Section";
import Title from "@/components/Section/Title";
import {
  Carousel,
  CarouselContent,
  CarouselItem,
  CarouselNext,
  CarouselPrevious,
} from "@/components/ui/carousel";
import {operationCommercial} from "@/types/operationCommercial";

function ModuleOperationCommercial({
  operations,
}: {
  operations?: operationCommercial[];
}): ReactElement {
  if (operations !== undefined) {
    const AllOpCo = operations?.map(
      (operationCommercial: operationCommercial, index) => {
        return (
          <CarouselItem
            className="carouselItem"
            key={`${operationCommercial.identifiant}_${index}`}>
            <OperationCommercial operation={operationCommercial} />
          </CarouselItem>
        );
      },
    );
    return (
      <Section id="operation-commercial">
        <Title
          title="Opérations commerciales"
          link="#"
          linkTitle="Voir toutes les Opération Commerciale"
          linkLabel="Tout voir"
        />

        {AllOpCo ? (
          <Carousel
            className="grab w-full flex justify-center items-center gap-2  "
            opts={{
              align: "start",
              loop: true,
            }}>
            <CarouselPrevious />

            <CarouselContent className="carouselContent">
              {AllOpCo}
            </CarouselContent>
            <CarouselNext />
          </Carousel>
        ) : (
          <div className="no-operation">
            <h4>Aucune opération en cours</h4>
          </div>
        )}
      </Section>
    );
  } else {
    return (
      <Section id="operation-commercial">
        <Carousel
          className="grab w-full flex justify-center items-center gap-2  "
          opts={{
            align: "start",
            loop: true,
          }}>
          <CarouselPrevious />

          <CarouselContent className="carouselContent">
            <CarouselItem className="carouselItem">
              <OperationCommercialSkeleton />
            </CarouselItem>
            <CarouselItem className="carouselItem">
              <OperationCommercialSkeleton />
            </CarouselItem>
            <CarouselItem className="carouselItem">
              <OperationCommercialSkeleton />
            </CarouselItem>
            <CarouselItem className="carouselItem">
              <OperationCommercialSkeleton />
            </CarouselItem>
          </CarouselContent>
          <CarouselNext />
        </Carousel>
      </Section>
    );
  }
}

export default ModuleOperationCommercial;
